import { createContext, useContext } from 'react';

export const PartnerPromoModalsContext = createContext({
  holidayHoursModalVisible: false,
  setHolidayHoursModalVisible: () => {},
  isLoyaltyModalOpen: false,
  setIsLoyaltyModalOpen: () => {},
});

export const usePartnerPromoModals = () => useContext(PartnerPromoModalsContext);
